import { useState, useEffect, useContext } from "react";
import { Box, Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import ApiService from "../../services/app.service";
import { SnackbarContext } from "../../App";
import InnerHeader from "../Layout/InnerHeader";
import SkeletonLoader from "../SkeletonLoader";
import FilterFields from "./FilterFields";
import ImageCordinates from "./ImageCordinates";
import ImageUpload from "./ImageUpload";
import Output from "./Output";
import SelectCoordinatesModal from "./SelectCoordinatesModal";

function ImageComparison() {
  const [Imgarea1, setImgarea1] = useState([]);
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [imgProps1, setImgProps1] = useState({ width: 0, height: 0 });
  const [outPut, setOutPut] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({
    threshold: 50,
    Comparison: "Strict",
    Highlight_Differences: true,
    count_to_get: 10,
    color: "rgb(255 0 0 / 52%)",
  });
  const { setSnack } = useContext(SnackbarContext);

  useEffect(() => {
    setImgarea1([]);
  }, [file1, file2]);

  const formatData = (compareData) => {
    const formattedData = [];
    compareData.forEach((element) => {
      const sam = {
        TopLeft: {},
        BottomRight: {},
      };
      sam.TopLeft = { X: Math.round(element.x), Y: Math.round(element.y) };
      sam.BottomRight = {
        X: Math.round(element.x + element.width),
        Y: Math.round(element.y + element.height),
      };
      formattedData.push(sam);
    });
    return formattedData;
  };

  const handleSubmit = async () => {
    setLoader(true);
    const data1 = {
      image_path_1: file1[0],
      image_path_2: file2[0],
      threshold: data.threshold,
      Comparison: data.Comparison,
      Highlight_Differences: data.Highlight_Differences,
      count_to_get: data.count_to_get,
      AreaToIgnore: formatData(Imgarea1),
    };
    const form_data = new FormData();
    Object.keys(data1).forEach((key) => {
      if (key === "AreaToIgnore") {
        form_data.append(key, JSON.stringify(data1[key]));
      } else {
        form_data.append(key, data1[key]);
      }
    });
    try {
      const response = await ApiService.imageComparision(form_data);
      if (response.data.Score_error) {
        setSnack({
          message: response.data.Score_error,
          open: true,
          colour: "warning",
        });
        setLoader(false);
      } else {
        setOutPut(response.data);
        setLoading(true);
        setLoader(false);
      }
    } catch {
      setLoader(false);
      setSnack({
        message: "Something went wrong",
        open: true,
        colour: "warning",
      });
    }
  };

  return (
    <Box className="imageComparison">
      <InnerHeader name={"Image Comparison"} />
      <Box>
        <Box>
          <Grid container className="headerImg" spacing={1} mb="16px">
            <Grid size={4}>
              <Typography variant="h6">
                Image 1 <AddPhotoAlternateOutlinedIcon />
              </Typography>
            </Grid>
            <Grid size={4}>
              <Typography variant="h6">
                Image 2 <AddPhotoAlternateOutlinedIcon />
              </Typography>
            </Grid>
            <Grid size={4}></Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid size={4}>
              <Box className="imgUpMain">
                <Box className="imgDisplay">
                  <SelectCoordinatesModal
                    Imgarea1={Imgarea1}
                    file={file1}
                    setImgarea1={setImgarea1}
                    data={data}
                    imgProps1={imgProps1}
                    setImgProps1={setImgProps1}
                  />
                </Box>
                <ImageUpload setFile={setFile1} file={file1} setLoading={setLoading} />
              </Box>
            </Grid>
            <Grid size={4}>
              <Box className="imgUpMain">
                <Box className="imgDisplay">
                  {file2 && (
                    <Box className="imgBox">
                      <img src={URL.createObjectURL(file2[0])} alt="my image" />
                    </Box>
                  )}
                </Box>
                <ImageUpload setFile={setFile2} file={file2} setLoading={setLoading} />
              </Box>
            </Grid>
            <Grid size={4}>
              <ImageCordinates
                Imgarea1={Imgarea1}
                setImgarea1={setImgarea1}
                file1={file1}
                file2={file2}
                setLoading={setLoading}
              />
            </Grid>
          </Grid>
        </Box>
        <Box>
          <FilterFields data={data} setData={setData} />
        </Box>
        <Box mt="16px" textAlign="center">
          <Button variant="contained" size="small" onClick={handleSubmit} disabled={!file1 || !file2}>
            Compare
          </Button>
        </Box>
        {!loader && loading && (
          <Box>
            <Output outPut={outPut} data={data} file1={file1} file2={file2} setOutPut={setOutPut} />
          </Box>
        )}
        {loader && <SkeletonLoader />}
      </Box>
    </Box>
  );
}
export default ImageComparison;
